import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { getReadableNumber } from "../../../utils/numberUtils";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
export const options = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
    title: {
      display: true,
      text: "EBIT",
    },
    datalabels: {
      display: false,
    },
  },

  scales: {
    y: {
      ticks: {
        display: true,
        autoSkip: false,
        callback: function (value, index, array) {
          return getReadableNumber(value);
        },
      },
    },
  },
};

const EbitChart = ({ data }) => {
  let ebitData = [];
  let ebitDate = [];
  data?.forEach((element) => {
    ebitData.push(element?.ebitReported);
    ebitDate.push(element?.periodEndDate);
  });

  const labels = ebitDate?.reverse();

  const chartData = {
    labels,
    datasets: [
      {
        label: "Dataset 1",
        data: ebitData?.reverse(),
        backgroundColor: "rgba(53, 162, 235, 0.5)",
      },
    ],
  };

  return (
    <div>
      <Bar options={options} data={chartData} />
    </div>
  );
};

export default EbitChart;
